<template>
  <table class="reportGrid">
    <tr>
      <td class="topLeft"></td>
      <td class="topCenter"></td>
      <td class="topRight"></td>
    </tr>
    <tr>
      <td class="middleLeft"></td>
      <td class="middleCenter page">
        <div class="subpage">
          <slot></slot>
        </div>
      </td>
      <td class="middleRight"></td>
    </tr>
    <tr>
      <td class="bottomLeft"></td>
      <td class="bottomCenter"></td>
      <td class="bottomRight"></td>
    </tr>
  </table>
</template>
<script>
  export default {
    name: 'ReportGrid',
    props: {
      width: {
        type: String,
        default: '800px'
      },
      height: {
        type: String,
        default: '500px'
      }
    },
    data () {
      return {
      }
    },
    created () {
    },
    mounted () {
    },
    methods: {
    }
  }
</script>
<style>
  .reportGrid {
    width: 100%;
    height: 100%;
  }

  .reportGrid > tr > td.topLeft {
    width: 30px;
    height: 30px;
    border-right: 1px dotted #999;
    border-bottom: 1px dotted #999;
  }
  .reportGrid > tr > td.topCenter {
    width: auto;
    height: 30px;
    border-bottom: 1px dotted #999;
  }
  .reportGrid > tr > td.topRight {
    width: 30px;
    height: 30px;
    border-left: 1px dotted #999;
    border-bottom: 1px dotted #999;
  }
  .reportGrid > tr > td.middleLeft {
    width: 30px;
    height: auto;
    border-right: 1px dotted #999;
  }
  .reportGrid > tr > td.middleCenter {
    padding: 5px;
    vertical-align: top;
    width: 100%;
    height: 100%;
  }
  .reportGrid > tr > td.middleRight {
    width: 30px;
    height: auto;
    border-left: 1px dotted #999;
  }
  .reportGrid > tr > td.bottomLeft {
    width: 30px;
    height: 30px;
    border-right: 1px dotted #999;
    border-top: 1px dotted #999;
  }
  .reportGrid > tr > td.bottomCenter {
    width: auto;
    height: 30px;
    border-top: 1px dotted #999;
  }
  .reportGrid > tr > td.bottomRight {
    width: 30px;
    height: 30px;
    border-left: 1px dotted #999;
    border-top: 1px dotted #999;
  }

</style>




// WEBPACK FOOTER //
// ReportGrid.vue?d43f69e0